import { ReactNode } from 'react';
import { FieldValues, useFormContext } from 'react-hook-form';
import { useTranslation } from 'next-i18next';

import { Heading } from '@restworld/ui-ds-base';

import {
  ContractType,
  JobType,
  DistanceFrom,
  SalaryRange,
  SeasonalJobPosition,
  YearsOfExperience,
  SalaryRating,
  CareerRating,
  DomainInterestQualificationField,
  PageContentField,
  // ShiftsSection,
} from '.';

export const ExplorerFormContent = ({
  handleFilterChange,
  children,
}: {
  handleFilterChange?: (values?: FieldValues) => Promise<void>;
  children?: ReactNode;
}) => {
  const { handleSubmit } = useFormContext();
  const { t } = useTranslation('job-explorer-page');
  return (
    <form className="relative w-full lg:mt-4" onSubmit={handleSubmit(handleFilterChange)}>
      <div className="flex flex-col gap-4 h-[calc(100svh_-_11rem)] overflow-y-auto pb-4 lg:pb-20 lg:h-[calc(100svh_-_20rem)]">
        <PageContentField />
        <hr />
        <DomainInterestQualificationField />
        <hr />
        <ContractType />
        <hr />
        <JobType />
        <hr />
        <DistanceFrom />
        <hr />
        <SalaryRange />
        <hr />
        <SeasonalJobPosition />
        <hr />
        <YearsOfExperience />
        <hr />
        <div className="flex flex-col gap-4 pb-28 lg:pb-0">
          <Heading>{t('what_restworld_makes')}</Heading>
          <SalaryRating />
          <CareerRating />
        </div>
      </div>
      {children}
    </form>
  );
};
